import merge from "lodash/merge";
import { createUseStyles, type Styles } from "react-jss";

import { animations } from "./transitions";

const transitionableStyles: Styles<"transitionable"> = {
  transitionable: {
    "&.out": {
      pointerEvents: "none",
    },
    "&:not(.animate).in": {
      pointerEvents: "none",
      visibility: "hidden",
    },

    "--animation-duration": "500ms",

    "willChange": "opacity, transform",
  },
};

// using merge and not safe merge because we want the key to contain special characters - "[], ()"
const styles: Styles<"transitionable"> = merge(transitionableStyles, animations);

export const useStyles = createUseStyles(styles);
